import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import BrowseCars from './pages/BrowseCars';
import BookInspection from './pages/BookInspection';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Connect from './pages/Connect';
import About from './pages/AboutUs';
import WhatsAppButton from './components/WhatsAppButton';
import Financing from './pages/Financing';
import LoanApplication from './pages/LoanApplication';
import EditCar from './components/EditCar';
import AddCar from './components/AddCar';
import InspectionsList from './components/InspectionsList';

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin') || location.pathname === '/admin-login';

  return (
    <>
      <Routes>
        <Route index element={<Home />} />
        <Route path="/browse" element={<BrowseCars />} />
        <Route path="/book-inspection" element={<BookInspection />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/*" element={<AdminDashboard />} />
        <Route path="/about" element={<About/>} />
        <Route path="/connect" element={<Connect />} />
        <Route path="/financing" element={<Financing />} />
         <Route path="/loan-application" element={<LoanApplication />} />
         <Route path="/admin/edit-car/:id" element={<EditCar />} />
        <Route path="/admin/add-car" element={<AddCar />} />
        <Route path="/admin/inspections" element={<InspectionsList />} />
      </Routes>
      {!isAdminPage && <WhatsAppButton />}
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
